module.exports = __webpack_public_path__ + "media/images/case-studies/mt-alexander-cee9b51aacd4c24ea77a48f7df4939a5.png";